import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AutoTexto from './autotexto.page';
import WebapiCommon from '@common/util/webapi.common';
import * as commomactions from '../../common.action';
import { editorRunat, editorUrl } from '../../../../constants/defaultValues';

function AutoTextoContainer(props) {
  const [textoBusca, setTextoBusca] = useState('');
  const [textoBuscaGeral, setTextoBuscaGeral] = useState('');
  const [autoTexto, setAutoTexto] = useState();
  const [autoTextoGeral, setAutoTextoGeral] = useState();
  const [filtrado, setFiltrado] = useState();
  const [filtradoGeral, setFiltradoGeral] = useState();

  const atualizaAutotexto = useSelector(
    (state) => state.commonReducer.atualizaAutotexto
  );
  const detalhes = useSelector((state) => state.commonReducer.detalhes);
  const dispatch = useDispatch();

  function atualizar() {
    dispatch(commomactions.showFadeCarregando(true));
    WebapiCommon.getListagemAutotexto(detalhes.exameId).then((listagem) => {
      setAutoTexto(listagem.length === 0 ? undefined : listagem);
      setFiltrado(listagem.length === 0 ? undefined : listagem);
    });

    //Get Autotexto Geral
    WebapiCommon.getListagemAutotextoGeral().then((listagemGeral) => {
    setAutoTextoGeral(listagemGeral.length === 0 ? undefined : listagemGeral);
    setFiltradoGeral(listagemGeral.length === 0 ? undefined : listagemGeral);
  });
  setTextoBusca('');
  setTextoBuscaGeral('');
  dispatch(commomactions.showFadeCarregando(false));
  }

  useEffect(() => {
    atualizar();
  }, []);

  useEffect(() => {
 if(atualizaAutotexto){
   atualizar();
   dispatch(commomactions.atualizaAutotexto(false));
 }
  }, [atualizaAutotexto]);

  function atualizaModal(val) {
    dispatch(commomactions.showModal(val));
  }

  function getAltura() {
    return (
      document.getElementById('container-editor') &&
      document.getElementById('container-editor').style.height
    );
  }

  function filtrar(texto) {
    setTextoBusca(texto);
    if (texto.length > 0) {
      texto = texto.toUpperCase();
      var filtrado = autoTexto.filter((item) => {
        return (
          item.nomeTexto.toUpperCase().replace(' ', '').indexOf(texto.replace(' ', '')) > -1 ||
          item.identificador.toUpperCase().replace(' ', '').indexOf(texto.replace(' ', '')) > -1
        );
      });

      if (!filtrado || filtrado.length === 0) {
      }

      setFiltrado(filtrado);
    } else {
      setFiltrado(autoTexto);
    }
  }
  function filtrarGeral(texto) {
    setTextoBuscaGeral(texto);
    if (texto.length > 0) {
      texto = texto.toUpperCase();
      const _filtradoGeral = autoTextoGeral.filter((item) => {
        return (
          item.nomeTexto.toUpperCase().replace(' ', '').indexOf(texto.replace(' ', '')) > -1
        );
      });

      if (!_filtradoGeral || _filtradoGeral.length === 0) {
      }

      setFiltradoGeral(_filtradoGeral);
    } else {
      setFiltradoGeral(autoTextoGeral);
    }
  }

  function obterAutotexto(id) {
    dispatch(commomactions.showFadeCarregando(true));
    WebapiCommon.getAutotexo(id).then((texto) => {
      dispatch(commomactions.showFadeCarregando(false));
      const frame = document.getElementById('iframe-editor');
      frame.contentWindow.postMessage(
        {
          method: 'inserirTexto',
          text: texto,
          type: 'rtf',
          runat: editorRunat,
          breakLine: false,
          cleanBefore: false,
        },
        editorUrl
      );
    });
  }

  return (
    <AutoTexto
      onModal={(e) => atualizaModal(e)}
      alturaEditor={(e) => getAltura(e)}
      autotexto={filtrado}
      autotextoGeral={filtradoGeral}
      obterAutotexto={(e) => obterAutotexto(e)}
      altura={props.altura}
      filtrar={(e) => filtrar(e)}
      filtrarGeral={(e) => filtrarGeral(e)}
      texto={textoBusca}
      textoGeral={textoBuscaGeral}
    />
  );
}

export default (AutoTextoContainer);



// WEBPACK FOOTER //
// ./src/app/common/tabs/autotexto/autotexto.container.js